import { Routes } from '@angular/router';
import { ErrorComponent } from './containers/error/error.component';
import { PAGES_PATH } from './shared/constants';
import { GlobalRouteGuard } from './shared/helpers/global-route-guard';
import { MODULE_ROUTES } from './module.routes';
import { NotFoundComponent } from './containers/not-found/not-found.component';

export * from './routes';

export const ROUTES: Routes = [
  {
    path: '',
    canActivate: [GlobalRouteGuard],
    children: [...MODULE_ROUTES],
  },
  {
    path: PAGES_PATH.Error,
    component: ErrorComponent,
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];
